// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Reset and font */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.leave_temp_outer {
  width: 100%;
  min-height: 450px;
  border: 1px solid #e6e4e4;
  border-radius: 8px;
  background-color: #fafafa;
  padding: 15px;
}

.leave_create_head h3 {
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 10px;
}

.leave_template_name {
  margin: 0px 14px;
  display: flex;
  gap: 30px;
}

.leave_template_name h4 {
  display: inline-block;
  font-size: 16px;
  color: #34495e;
  margin-right: 10px;
}

.leave_template_name input {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 250px;
  font-size: 14px;
}

.leave_comp_outer {
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  padding: 20px;
  background-color: #ffffff;
}

.leave_comp_table {
  border: 1px solid #b5b5b5;
  border-radius: 8px;
  width: 45%;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
}

.leave_comp_table::-webkit-scrollbar {
  width: 6px;
}

.leave_comp_table::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}

.leave_comp_table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
}

.leave_comp_table th {
  background-color: #deecdd;
  position: sticky;
  top: 0;
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #2c3e50;
  border-bottom: 1px solid #ccc;
}

/* First column = Leave (90%) | Second column = Remove (10%) */
.leave_comp_table th:nth-child(1),
.leave_comp_table td:nth-child(1) {
  width: 90%;
  text-align: center;
}

.leave_comp_table th:nth-child(2),
.leave_comp_table td:nth-child(2) {
  width: 15%;
  text-align: center;
  white-space: nowrap;
}

.leave_comp_table tbody tr {
  transition: background-color 0.2s ease;
}

.leave_comp_table tbody tr:nth-child(odd) {
  background-color: #f4f4f4;
}

.leave_comp_table td {
  cursor: pointer;
  font-weight: 500;
  font-size: 13px;
  text-align: center;
  padding: 8px;
  vertical-align: middle;
}

.leave_comp_table button {
  cursor: pointer;
  padding: 4px 10px;
  font-size: 11px;
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease;
  color: #df3232;
}

.leave_comp_table button:hover {
  background-color: #d3dbe0;
}

.leave_comp_table button.remove-btn {
  background-color: #e74c3c;
}

.leave_comp_table button.remove-btn:hover {
  background-color: #c0392b;
}

.leave_back_btn_container {
  display: flex;
  margin-top: -9px;
  gap: 5px;
}

.leave_back_btn_container button {
  cursor: pointer;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  transition: background 0.3s ease;
}

.leave_back_btn_container button:hover {
  background-color: #e2e8ea;
}

.leave_submit_btn {
  background-color: #74c5a7;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s ease;
}

.leave_submit_btn:hover {
  background-color: #74c5a7c4;
}

.leave_comp_table {
  border: 1px solid #b5b5b5;
  border-radius: 8px;
  width: 45%;
  height: 300px; /* Fixed height */
  overflow: hidden;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
}

.leave_comp_table thead {
  flex: 0 0 auto;
}

.leave_comp_table tbody {
  flex: 1 1 auto;
  overflow-y: auto;
  display: block;
}

.leave_comp_table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.leave_comp_table thead tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.leave_comp_table::-webkit-scrollbar {
  width: 6px;
}

.leave_comp_table::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}

.temp_back_btn_container {
  margin-top: 10px;
}






/* leaves template css */


.leave-template-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 14px;
  background-color: #f9f9f9;
}

.leave-template-table th,
.leave-template-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

.leave-template-table th {
  background-color: #e6f4ea;
  color: #2d6a4f;
  font-weight: 600;
}

/* Equal width for name, description, leaves */
.leave-col {
  width: 25%;
}

/* Narrower column for actions */
.leave-action-col {
  width: 15%;
}

/* Style buttons inside actions */
.leave-actions button {
  margin-right: 5px;
  padding: 5px 8px;
  font-size: 12px;
  background-color: #eef0f2;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.leave-actions button:hover {
  background-color: #d5e0e5;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/DefineLeaveTemplate/leaveTemplate.css"],"names":[],"mappings":";AACA,mBAAmB;AACnB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D;;EAEE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,aAAa,EAAE,iBAAiB;EAChC,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;;;;;;AAOA,wBAAwB;;;AAGxB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["\n/* Reset and font */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.leave_temp_outer {\n  width: 100%;\n  min-height: 450px;\n  border: 1px solid #e6e4e4;\n  border-radius: 8px;\n  background-color: #fafafa;\n  padding: 15px;\n}\n\n.leave_create_head h3 {\n  font-size: 20px;\n  color: #2c3e50;\n  margin-bottom: 10px;\n}\n\n.leave_template_name {\n  margin: 0px 14px;\n  display: flex;\n  gap: 30px;\n}\n\n.leave_template_name h4 {\n  display: inline-block;\n  font-size: 16px;\n  color: #34495e;\n  margin-right: 10px;\n}\n\n.leave_template_name input {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 250px;\n  font-size: 14px;\n}\n\n.leave_comp_outer {\n  display: flex;\n  gap: 20px;\n  width: 100%;\n  flex-wrap: wrap;\n  border: 1px solid #dbdbdb;\n  border-radius: 8px;\n  padding: 20px;\n  background-color: #ffffff;\n}\n\n.leave_comp_table {\n  border: 1px solid #b5b5b5;\n  border-radius: 8px;\n  width: 45%;\n  max-height: 300px;\n  overflow-y: auto;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.leave_comp_table::-webkit-scrollbar {\n  width: 6px;\n}\n\n.leave_comp_table::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 3px;\n}\n\n.leave_comp_table table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 5px;\n}\n\n.leave_comp_table th {\n  background-color: #deecdd;\n  position: sticky;\n  top: 0;\n  text-align: center;\n  padding: 10px;\n  font-size: 14px;\n  color: #2c3e50;\n  border-bottom: 1px solid #ccc;\n}\n\n/* First column = Leave (90%) | Second column = Remove (10%) */\n.leave_comp_table th:nth-child(1),\n.leave_comp_table td:nth-child(1) {\n  width: 90%;\n  text-align: center;\n}\n\n.leave_comp_table th:nth-child(2),\n.leave_comp_table td:nth-child(2) {\n  width: 15%;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.leave_comp_table tbody tr {\n  transition: background-color 0.2s ease;\n}\n\n.leave_comp_table tbody tr:nth-child(odd) {\n  background-color: #f4f4f4;\n}\n\n.leave_comp_table td {\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 13px;\n  text-align: center;\n  padding: 8px;\n  vertical-align: middle;\n}\n\n.leave_comp_table button {\n  cursor: pointer;\n  padding: 4px 10px;\n  font-size: 11px;\n  border: none;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n  color: #df3232;\n}\n\n.leave_comp_table button:hover {\n  background-color: #d3dbe0;\n}\n\n.leave_comp_table button.remove-btn {\n  background-color: #e74c3c;\n}\n\n.leave_comp_table button.remove-btn:hover {\n  background-color: #c0392b;\n}\n\n.leave_back_btn_container {\n  display: flex;\n  margin-top: -9px;\n  gap: 5px;\n}\n\n.leave_back_btn_container button {\n  cursor: pointer;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  transition: background 0.3s ease;\n}\n\n.leave_back_btn_container button:hover {\n  background-color: #e2e8ea;\n}\n\n.leave_submit_btn {\n  background-color: #74c5a7;\n  color: #fff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: 0.3s ease;\n}\n\n.leave_submit_btn:hover {\n  background-color: #74c5a7c4;\n}\n\n.leave_comp_table {\n  border: 1px solid #b5b5b5;\n  border-radius: 8px;\n  width: 45%;\n  height: 300px; /* Fixed height */\n  overflow: hidden;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n}\n\n.leave_comp_table thead {\n  flex: 0 0 auto;\n}\n\n.leave_comp_table tbody {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  display: block;\n}\n\n.leave_comp_table tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.leave_comp_table thead tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.leave_comp_table::-webkit-scrollbar {\n  width: 6px;\n}\n\n.leave_comp_table::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 3px;\n}\n\n.temp_back_btn_container {\n  margin-top: 10px;\n}\n\n\n\n\n\n\n/* leaves template css */\n\n\n.leave-template-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  font-size: 14px;\n  background-color: #f9f9f9;\n}\n\n.leave-template-table th,\n.leave-template-table td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: center;\n}\n\n.leave-template-table th {\n  background-color: #e6f4ea;\n  color: #2d6a4f;\n  font-weight: 600;\n}\n\n/* Equal width for name, description, leaves */\n.leave-col {\n  width: 25%;\n}\n\n/* Narrower column for actions */\n.leave-action-col {\n  width: 15%;\n}\n\n/* Style buttons inside actions */\n.leave-actions button {\n  margin-right: 5px;\n  padding: 5px 8px;\n  font-size: 12px;\n  background-color: #eef0f2;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.leave-actions button:hover {\n  background-color: #d5e0e5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
